<template>
    <div>
        <v-card-title>
            Accounts
            <v-spacer></v-spacer>
            <v-checkbox class="pr-2"
                    v-model="showTestUser"
                    label="Show test user"
                    @click="doSearch"
            >
            </v-checkbox>
            <v-checkbox
                    v-model="createdAfter"
                    label="Created After"
            >
            </v-checkbox>
            <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                            :disabled="!createdAfter"
                            class="ps-9"
                            v-model="date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker
                        v-model="date"
                        no-title
                        scrollable
                >
                    <v-spacer></v-spacer>
                    <v-btn
                            text
                            color="primary"
                            @click="menu = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            text
                            color="primary"
                            @click="saveDateAndSearch"
                    >
                        OK
                    </v-btn>
                </v-date-picker>
            </v-menu>
            <v-text-field
                    class="ps-9"
                    :rules="searchRules"
                    v-model="search"
                    append-icon="mdi-magnify"
                    @click:append="doSearch"
                    label="Search id or partner id"
                    @keyup.enter="doSearch"
                    single-line
            ></v-text-field>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="accounts"
                :options.sync="options"
                :server-items-length="totalElements"
                :loading="loading"
                :footer-props="{
                    itemsPerPageOptions: [5, 10, 20, 50]
                }"
                @click:row="chooseParticipant"
                class="elevation-1"
        >
            <template v-slot:item.testUser ="{ item }">
                <v-simple-checkbox
                        v-model="item.testUser"
                        disabled
                ></v-simple-checkbox>
            </template>
        </v-data-table>
    </div>
</template>


<script>
    import constants from "../constants";

    export default {
        data() {
            return {
                totalElements: 0,
                accounts: [],
                loading: true,
                options: {},
                headers: [
                    {
                        text: 'Id',
                        align: 'start',
                        value: 'id',
                    },
                    {text: 'Partner Id', value: 'partnerId'},
                    {text: 'Created Date', value: 'createdDate'},
                    {text: 'Test User', value: 'testUser'},
                    {text: 'Blocked', value: 'blocked'},
                    {text: 'Blocked Reason', value: 'blockedReason'}
                ],
                menu: false,
                search: '',
                date: null,
                createdAfter: false,
                searchRules: [
                    v => v.length >= 3 || v.length === 0 || 'At least three characters',
                ],
                showTestUser: false
            }
        },
        mounted() {
            this.getDataFromApi()
                .then(data => {
                    this.accounts = data.items
                    this.totalElements = data.total
                })
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                        .then(data => {
                            this.accounts = data.items
                            this.totalElements = data.total
                        })
                },
                deep: true,
            },
        },
            methods: {
            async getDataFromApi() {
                this.loading = true
                let {sortBy, sortDesc, page, itemsPerPage} = this.options
                page -= 1; // Because spring page starts with 0
                let response = await this.getAccounts(sortBy, sortDesc, page, itemsPerPage)
                let items = response.content
                const total = response.totalElements
                this.loading = false
                return {items, total}
            },
            chooseParticipant(value) {
                this.$emit('openDetails', value)
            },
            async getAccounts(sortBy, sortDesc, page, itemsPerPage) {
                return this.$http.get(constants.ACCOUNT_ENDPOINT, {
                    params: {
                        'partnerId': this.search,
                        'createdDate': this.createdAfter ? this.date : null,
                        'page': page,
                        'size': itemsPerPage,
                        'testUser': this.showTestUser
                    },
                    withCredentials: true
                })
                    .then(response => response.data)
                    .catch(error => {
                        console.log(error)
                        //this.$log.error('Error in getting template ids: ', error)
                    });
            },
            doSearch() {
                if(this.search.length >= 3 || this.search.length === 0 || this.date) {
                    this.getDataFromApi()
                        .then(data => {
                            this.accounts = data.items
                            this.totalElements = data.total
                        })
                }
            },
            saveDateAndSearch() {
                this.$refs.menu.save(this.date);
                this.doSearch();
            }
        },

    }
</script>
